import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import useDocumentTitle from "../../hook/useDocumentTitle";

export default function NotFound() {
  const { t } = useTranslation("notFound");
  useDocumentTitle(t("documentTitle"));

  return <main className="min-h-screen flex flex-col items-center justify-center gap-4 p-8">
    <h1 className="text-4xl font-semibold text-gray-900">{t("heading")}</h1>
    <Link to="/" className="text-accent hover:opacity-75 transition-opacity duration-300">
      {t("backHome")}
    </Link>
  </main>
}
